/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3.transition
 */
export default class Transition extends PIXI.Container {
    constructor() {
        super();

        /**
         * @member {Object}
         */
        this.signals = {};

        /**
         * @member {signals.Signal}
         */
        this.signals.in = new signals.Signal();

        /**
         * @member {signals.Signal}
         */
        this.signals.out = new signals.Signal();

        this.on("added", this.init, this);
    }

    init() {
        this.off("added", this.init);
    }

    /**
     * @param options
     * @param [options.children=false]
     * @param [options.texture=false]
     * @param [options.baseTexture=false]
     */
    destroy(options) {
        this.signals.in.dispose();
        this.signals.out.dispose();

        super.destroy(options);
    }

    /**
     */
    in() {
        this.signals.in.dispatch(this);
    }

    /**
     */
    out() {
        this.signals.out.dispatch(this);
    }

    /**
     */
    resize() {
        // override
    }
}
